import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router';
import { toast } from 'sonner';

/**
 * A UX-only guard redirect that explains itself: it fires a toast once, then replaces the
 * current entry with `to`. Used by the route guards (ADR 0015) so a stale or unauthorized URL
 * lands the user somewhere safe with a clear message rather than on a forbidden screen. The
 * toast fires in an effect (not during render) and only once, even if React re-renders before
 * the navigation commits.
 */
export function RedirectWithToast({ to, message }: { to: string; message: string }) {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    toast.error(message);
  }, [message]);
  return <Navigate to={to} replace />;
}
